function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import Modal from "./Modal";
import Spinner from "./Spinner";

var noop = function noop() {};
/**
 * A 'Waiting' indicator for unknown durations. See https://qa.qa.appfolio.com/gears/waiting
 */


var Waiting = function Waiting(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Please Wait' : _ref$title,
      props = _objectWithoutProperties(_ref, ["children", "className", "title"]);

  return /*#__PURE__*/React.createElement(Modal, _extends({}, props, {
    className: className,
    contentClassName: "bg-dark border-0 text-center text-light",
    toggle: noop,
    style: {
      margin: '40vh auto',
      width: '9rem'
    }
  }), title ? /*#__PURE__*/React.createElement("header", {
    className: "px-4 pt-4"
  }, title) : null, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, children || /*#__PURE__*/React.createElement(Spinner, {
    style: {
      fontSize: '30px'
    }
  })));
};

Waiting.displayName = "Waiting";
Waiting.defaultProps = {
  title: 'Please Wait'
};
Waiting.displayName = 'Waiting';
export default Waiting;